import React, { useContext } from "react";
import * as notify from "../../../shared/notify";

import AttributeInputField from "../../attributes/compare-table/attribute-input-field";
import Attributes from "../../../contexts/attributes/attributes";

import { findField } from "../../attributes/compare-table/field-builder";
import { AttributesContext, ProductsContext } from "../../../contexts/attributes";
import { getDefaultValueByType } from "../../attributes/lib/attribute-data";
import { SourcePage } from "shared/taskTypeMap";

const buildDefaultState = (definitions) => {
    const defaults = definitions.reduce((obj, def) => {
        obj[def.uuid] = getDefaultValueByType(def.componentType);

        return obj;
    }, {});

    return { ...defaults };
};

const BulkSetButton = ({ defaultValues }) => {
    const { bulkUpdate } = useContext(ProductsContext);
    const attributes = useContext(AttributesContext);
    const onBulkSet = async (e) => {
        e.preventDefault();

        const updatedValues = {};
        Object.keys(defaultValues).forEach((uuid) => {
            if (attributes.data[uuid] !== defaultValues[uuid]) {
                updatedValues[uuid] = attributes.data[uuid];
            }
        });

        if (Object.keys(updatedValues).length === 0) {
            notify.warning("Please select a value to be updated");

            return;
        }

        const didUpdate = await bulkUpdate({ ...updatedValues });

        if (didUpdate) {
            attributes.reset({ ...defaultValues });
        } else {
            notify.warning("Please select an item for bulk update first");
        }
    };

    const onReset = () => {
        attributes.reset({ ...defaultValues });
    };

    return (
        <div className="button-group -right">
            <button className="button" onClick={onReset}>
                Reset
            </button>
            <button className="button -primary" onClick={onBulkSet}>
                Bulk Set
            </button>
        </div>
    );
};

const BulkChange = ({ definitions }) => {
    const defaultValues = buildDefaultState(definitions);

    const attributes = definitions.map((attr) => {
        const newAttr = { ...attr };
        newAttr.required = false;
        newAttr.validation = { ...attr.validation, required: false };

        const Field = findField(newAttr.componentType);

        return (
            <div key={`schedulingEdit_${newAttr.uuid}`}>
                <label>{newAttr.name}: </label>
                <AttributeInputField id={`bulk_${newAttr.uuid}`} name={`bulk_${newAttr.uuid}`} Field={Field} attribute={newAttr} />
            </div>
        );
    });

    return (
        <div className="bulk-change">
            <Attributes
                defaultValues={{ ...defaultValues }}
                useTask={{
                    task: {
                        sourcePage: SourcePage["scheduling.default"],
                        key: "bulk",
                        context: { codingWipKey: "" },
                        taskType: "scheduling.default",
                    },
                }}
            >
                <h3>Bulk Change:</h3>
                <div className="bulk-attributes">{attributes}</div>

                <div className="input-group -right">
                    <BulkSetButton defaultValues={defaultValues} />
                </div>
            </Attributes>
        </div>
    );
};

export default BulkChange;
